import React, {Component} from 'react';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  Modal,
  ModalFooter,
  Table
} from 'reactstrap';

import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import StudentPage from '../../views/StudentPage/';
const GLOBAL = require('../../Globals');

class Leaverequest extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			 id : '',
			loading: false,
			showModal: false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			//value : '',
			alertClass :'',
			//_redirect : false,
			posts: []
		}

		this.toggle = this.toggle.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.apprClick = this.apprClick.bind(this);
		this.rejClick = this.rejClick.bind(this);
	}
	
	toggle(e){
		this.setState({showModal : false});
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		this.getdata();
	}
	
	onSMS(regno){
		this.setState({showModal : true,regno,regno});
	}

	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}

	onSMSSubmit(){
		if (window.confirm("Do you want to Send SMS?")) { 
			$("#showLoader").show();
			GetData('leave/sendsms/',this.state.regno+'/'+this.state.message).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'SMS Send Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Send SMS',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('leave/removeleaveapp',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Leave Request Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Leave Request',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	apprClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Approve?")) {
				$("#showLoader").show();
			PostData('leave/apprleaveapp',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Leave Request Approved Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Approve Leave Request',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	rejClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Reject?")) {
				$("#showLoader").show();
			PostData('leave/rejleaveapp',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Leave Request Rejected Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Reject Leave Request',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	componentWillMount() {
		this.getdata();
	}
	
	getdata(){
		this.setState({loading:true});
		$("#showLoader").show();
		GetData('leave/mobleavereqs').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					loading:false
				});
			}
		});
	}
	
	
  render() {
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item}>
				<td width="20">{i+1}</td>
				<td width="100">{item.regno}</td>
				<td width="100">{item.stname}</td>
				<td width="100">{item.classname}</td>
				<td width="100">{item.secname}</td>
				<td width="100">{item.fromdate}</td>
				<td width="100">{item.todate}</td>
				<td width="100">{item.reason}</td>
				<td width="100">{item.isapproved === '1' ? 'Approved' : 'Pending'}</td>
				<td width="30">
				{item.isapproved === '1' ? 
				
					<button name="sendhw" className="btn btn-warning btn-sm" onClick={() => this.rejClick(item.id)} ><i className="fa fa-ban"></i></button>
				:
				
				<button name="sendhw" className="btn btn-primary btn-sm"  onClick={() => this.apprClick(item.id)} ><i className="fa fa-check"></i></button>
				
				}	
					<button name="sms" className="btn btn-success btn-sm" onClick={this.onSMS.bind(this,item.regno)}><i className="fa fa-message"></i></button>
				
					&nbsp;
					<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
				</td>
			</tr>;
	});
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
				   		<CardHeader>
							<strong>Leave Requests</strong>
							
						</CardHeader>
						<CardBody>
							<select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
							<Table responsive bordered>
								<thead>
									<tr>
										<th>S.No</th>
										<th>Regno</th>
										<th>Student Name</th>
										<th>Class</th>
										<th>Section</th>
										<th>Start Date</th>
										<th>End Date</th>
										<th>Reason</th>
										<th>Status</th>
										<th width="100">Manage</th>
									</tr>
								</thead>
								<tbody>
									{this.state.loading ?  <tr><td colSpan="10"><center><Loader /></center></td></tr> : renderTodos}
									<br></br>
									<Pagination
										activePage={this.state.activePage}
										itemsCountPerPage={this.state.todosPerPage}
										pageRangeDisplayed={3}
										totalItemsCount={this.state.posts.length}
										onChange={this.handlePageChange}
										/>
								</tbody>
							</Table>
						</CardBody>
				   	</Card>
				  </Col>
				   <Modal isOpen={this.state.showModal} toggle={this.toggle} className={this.props.className}>
						<ModalHeader toggle={this.toggle}>Edit Template</ModalHeader>
						<ModalBody>
						<Row>
							<Col md="2">
							<FormGroup>
								<Label htmlFor="name">Message</Label>
							</FormGroup>
							</Col>
							<Col md="10">
							<FormGroup>
								<Input type="textarea" name="message" id="message" onChange={this.onChange} rows="4" required />
							</FormGroup>
							</Col>
						</Row>
						</ModalBody>
						<ModalFooter>
						<Button size="sm" color="primary" onClick={this.onSMSSubmit}><i className="fa fa-dot-circle-o"></i> Update</Button>
						<Button size="sm" color="secondary" onClick={this.toggle}>Cancel</Button>
						</ModalFooter>
					</Modal>
				</Row>
			</div>
		</div>
	)
  }
}

export default Leaverequest;


// WEBPACK FOOTER //
// ./src/leave/mobilereq/leaverequest.js